<script>
  // @ts-nocheck

  import Spinner from './Spinner.svelte';

  export let rightIcon = null;
  export let isDisabled = false;
  export let isLoading = false;
  export let label = 'Submit';
  export let type = 'submit';
  export let color = undefined;
  export let form = null;
  export let additionalClasses = '';

  export let onClick;
</script>

<button
  {form}
  class:secondary={color === 'secondary'}
  on:click={onClick}
  disabled={isDisabled}
  {type}
  class="inline-block rounded border border-indigo-600 bg-indigo-600 px-8 py-3 text-sm font-medium text-white hover:bg-transparent hover:text-indigo-600 focus:outline-none focus:ring active:text-indigo-500 disabled:bg-indigo-600 disabled:opacity-60 disabled:text-white disabled:cursor-not-allowed disabled:hover:border-indigo-600 {additionalClasses}"
>
  <div class="flex justify-center relative gap-2">
    {#if isLoading}
      <div class="relative top-0.5">
        <Spinner />
      </div>
    {/if}
    <span class="whitespace-nowrap">
      {label}
    </span>
    {#if rightIcon}
      <span class="icon">{@html rightIcon}</span>
    {/if}
  </div>
</button>

<style lang="postcss">
  button.secondary {
    @apply inline-block rounded bg-transparent text-indigo-600 hover:border-indigo-200 px-12 py-3 text-sm font-medium active:text-indigo-500 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:border-indigo-600;
  }
</style>
